// extracted by mini-css-extract-plugin
module.exports = {"page":"_1XgOw88","container":"_1wgca4_ _1ZWPIqK","application_content":"_3gkii3Z","controls":"_6z7WwMI"};